import React from "react";
import {Fragment} from "react";
import {Document, StyleSheet, View, Text} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    row: {
        flexDirection: "row",
        width: "100%",
        alignSelf: "center",
        justifyContent: "center",
    },
    header_column: {
        flexDirection: "column",
        alignItems: "center",
        border: true,
        fontWeight: "bold",
        fontSize: 10,
        width: "20%"
    },
    no_column: {
        flexDirection: "column",
        alignItems: "center",
        border: true,
        fontWeight: "bold",
        fontSize: 10,
        width: "10%"
    },
    data_column: {
        flexDirection: "column",
        alignItems: "center",
        border: true,
        fontWeight: "bold",
        fontSize: 10,
        width: "20%"
    },
});

const ItemsTable = ({data}, {rowNum}) => (
    <View style={styles.tableContainer}>
        { rowNum === 3 } ?
        <TableHeader6 header={data.header}/>
        <TableRow6 items={data.items}/>
    </View>
);

const TableHeader = ({header}) => (
    <View style={styles.row} key={header[0]}>
        <Text style={styles.no_column} key={header[0].object1}>{header[0].object1}</Text>
        <Text style={styles.header_column} key={header[0].object2}>{header[0].object2}</Text>
        <Text style={styles.header_column} key={header[0].object3}>{header[0].object3}</Text>
        <Text style={styles.header_column} key={header[0].object4}>{header[0].object4}</Text>
    </View>
);

const TableHeader6 = ({header}) => (
    <View style={styles.row} key={header[0]}>
        <Text style={styles.no_column} key={header[0].object1}>{header[0].object1}</Text>
        <Text style={styles.header_column} key={header[0].object2}>{header[0].object2}</Text>
        <Text style={styles.header_column} key={header[0].object3}>{header[0].object3}</Text>
        <Text style={styles.header_column} key={header[0].object4}>{header[0].object4}</Text>
        <Text style={styles.header_column} key={header[0].object5}>{header[0].object5}</Text>
        <Text style={styles.header_column} key={header[0].object6}>{header[0].object6}</Text>
    </View>
);

const TableRow = ({items}) => {
    const rows = items.map((item) => (
        <View style={styles.row} key={item.object1}>
            <Text style={styles.no_column} key={item.object1}>{item.object1}</Text>
            <Text style={styles.data_column} key={item.object2}>{item.object2}</Text>
            <Text style={styles.data_column} key={item.object3}>{item.object3}</Text>
            <Text style={styles.data_column} key={item.object4}>{item.object4}</Text>
        </View>
    ));
    return <Fragment>{rows}</Fragment>;
};

const TableRow6 = ({items}) => {
    const rows = items.map((item) => (
        <View style={styles.row} key={item.object1}>
            <Text style={styles.no_column} key={item.object1}>{item.object1}</Text>
            <Text style={styles.data_column} key={item.object2}>{item.object2}</Text>
            <Text style={styles.data_column} key={item.object3}>{item.object3}</Text>
            <Text style={styles.data_column} key={item.object4}>{item.object4}</Text>
            <Text style={styles.data_column} key={item.object5}>{item.object5}</Text>
            <Text style={styles.data_column} key={item.object6}>{item.object6}</Text>
        </View>
    ));
    return <Fragment>{rows}</Fragment>;
};
const Table = ({data}, {rowNum}) => (
    <Document>
        <ItemsTable data={data} rowNum={rowNum}/>
    </Document>
);



function getTableHeader(data, rowNum){
    switch (rowNum){
        case 6 :
            return <TableHeader6 header={data.header}> </TableHeader6>
    }

}
export default Table;